// @ts-nocheck
import dayjs from 'dayjs';
/**
 * @deprecated use anything else
 */
export function sortByDate<Item extends object>(
  items: Array<Item>,
  dateKey: string,
  order: 'oldestFirst' | 'newestFirst' = 'newestFirst',
): Array<Item> {
  const sorted = items.sort((a, b) => {
    const dateA = dayjs(a[dateKey]);
    const dateB = dayjs(b[dateKey]);
    return dateA.valueOf() - dateB.valueOf();
  });

  return order === 'newestFirst' ? sorted.reverse() : sorted;
}
